import { For, Show } from "solid-js";
import "./ProfilePanelSocials.css";
import { VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { type Platform, ProfilePanelSocial } from "./ProfilePanelSocial";

type Props = {
	platforms: Platform[];
};

export const ProfilePanelSocials = (props: Props) => {
	return (
		<Show when={props.platforms.length > 0}>
			<VStack spacing="medium">
				<Text
					family="mono"
					transform="uppercase"
					weight="bold"
					size="small"
					color="fg3"
				>
					Socials
				</Text>
				<For each={props.platforms}>
					{(platform) => <ProfilePanelSocial platform={platform} />}
				</For>
			</VStack>
		</Show>
	);
};
